import React, { useState } from 'react';
import { isClient } from '../lib/utils';
// default delay before accepting an impression as valid
// in case the user scrolls too fast and doesnt actually see the content
const IMPRESSION_TIMEOUT = 1000;
const TrackImpressionEvent = ({ children, acceptableVisiblityRatio = 0.5, trackCallback, impressionDelayMs = IMPRESSION_TIMEOUT, }) => {
    // there are no impression events on server side :)
    if (!isClient()) {
        return React.createElement("div", null, children);
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [isObserverAttached, setIsObserverAttached] = useState(false);
    let observer;
    let timeOutid;
    const intersectionCallback = (entries) => {
        entries.forEach((entry) => {
            const { intersectionRatio } = entry;
            if (intersectionRatio > acceptableVisiblityRatio) {
                timeOutid = setTimeout(() => {
                    trackCallback();
                    observer.disconnect();
                }, impressionDelayMs);
            }
            else {
                clearTimeout(timeOutid);
            }
        });
    };
    const onRef = (el) => {
        if (el && !isObserverAttached) {
            observer.observe(el);
            setIsObserverAttached(true);
        }
    };
    // Even though we use DOM API in the component render cycle here,
    // it works with SSR because of early return at the beginning of the function.
    // TODO: Consider improving that by using useEffect,
    //  as this would make it possible to stop observing elements.
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    observer = new IntersectionObserver(intersectionCallback, {
        root: null,
        rootMargin: '0px',
        threshold: [acceptableVisiblityRatio],
    });
    return React.createElement("div", { ref: onRef }, children);
};
export default TrackImpressionEvent;
//# sourceMappingURL=TrackImpressionEvent.js.map